// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4lBGN","importantInfo":"styles_importantInfo__tSn9a"};